export default __webpack_public_path__ + "static/media/snackies.a080752b.png";